import AuthorCard from './AuthorCard'

export default AuthorCard